<template>
    <VDropdown
        :prevent-overflow="false"
        :overflow-padding="60"
        auto-boundary-max-size
        placement="top-start"
        theme="myTheme"
        :skidding="0"
        :distance="8"
    >
        <slot />
        <template #popper="{ hide }">
            <div class="chat_emoji_dropdown">
                <div>
                    <fa
                        :icon="['fal', 'search']"
                        class="mr-2 text-2xl text-gray-500"
                    ></fa>
                </div>
                <EmojiPicker
                    class="chat_emoji"
                    skinTone=""
                    :disable-skin-tones="true"
                    :disable-sticky-group-names="true"
                    :display-recent="false"
                    :hide-group-icons="true"
                    :hide-group-names="true"
                    :native="true"
                    @select="(onSelectEmoji($event))"
                />
            </div>
        </template>
    </VDropdown>
</template>

<script setup>
import EmojiPicker from 'vue3-emoji-picker';
import 'vue3-emoji-picker/css';
import { options } from 'floating-vue';
const props = defineProps({
    attachEmoji: {
        type: Function,
    },
});
options.themes.myTheme = {
    $extend: 'dropdown',
};
const { attachEmoji } = props;
// event callback
function onSelectEmoji(emoji) {
    if (attachEmoji) attachEmoji(emoji.i);
}
</script>

<style>
.v-popper--theme-emojiMenu .v3-emoji-picker {
    @apply !m-0 !w-full;
}
.v-popper--theme-emojiMenu .v3-emoji-picker .v3-footer {
    display: none !important;
}
.v-popper--theme-emojiMenu .v-popper__inner {
    @apply !overflow-hidden;
}
.v-popper--theme-emojiMenu .v3-header {
    @apply !p-0;
}
.v-popper--theme-emojiMenu .v3-search input {
    @apply !p-4 !rounded-none !h-[3.0625rem] !text-sm !text-gray-100 !border-none;
}
.v-popper--theme-emojiMenu .v3-emoji-picker .v3-body {
    @apply !p-0;
}
.v-popper--theme-emojiMenu .v3-body-inner {
    @apply !p-4;
}
.v-popper--theme-emojiMenu .v3-body-inner::-webkit-scrollbar {
    @apply !hidden;
}
.face-smile-btn svg {
    color: var(--gray-text, #a3a3a3);
    font-family: 'Font Awesome 6 Pro';
    font-size: 20px;
    font-style: normal;
    font-weight: 300;
    line-height: normal;
    margin-right: 8px;
}
.v-popper--some-open--myTheme .v-popper--theme-myTheme .v-popper__inner {
    max-width: 310px !important;
    min-width: 310px !important;
    width: 100% !important;
}
.chat_emoji .v3-footer {
    display: none;
}
.v3-emoji-picker {
    margin: 0 !important;
    overflow-x: hidden !important;
    width: 100% !important;
}
.v3-emoji-picker .v3-search input {
    border-color: white !important;
    margin-left: 20px !important;
}
.v3-emoji-picker .v3-search input::placeholder {
    color: var(--Gray-text, #bac4cd);
    font-size: 14px;
    font-style: normal;
    font-weight: 400;
    line-height: normal;
}
.chat_emoji_dropdown svg {
    color: var(--Gray-text, #bac4cd);
    font-family: 'Font Awesome 6 Pro';
    font-size: 16px;
    font-style: normal;
    font-weight: 400;
    left: 20px;
    line-height: normal;
    position: absolute;
    top: 19px;
}
</style>
